import CompanyServicesTab from './CompanyServicesTab';

export default CompanyServicesTab;
